module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-left.c0c0e816.svg";